<script>
import Dialog from './dialog-mask.vue'
export default {
  components: {
    Dialog
  },
  props: {
    list: {
      type: Array
    },
    selectedList: {
      type: Array
    },
    value: {}
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    async show () {
      // await this.$emit('fetch')
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    select (index, id) {
      const item = this.selectedList[index]
      if (id === -1) {
        this.$set(this.selectedList, index, [-1])
      } else {
        const i = item.indexOf(-1)
        i > -1 && item.splice(i, 1)
        const j = item.indexOf(id)
        if (j > -1) {
          item.splice(j, 1)
        } else {
          item.push(id)
        }
        if (item.length === 0) {
          this.$set(this.selectedList, index, [-1])
        }
      }
    },
    search () {
      this.$emit('search')
      this.hide()
    },
    input (event) {
      this.$emit('input', event.target.value)
    },
    activeClassname (index, id) {
      const item = this.selectedList[index]
      return ~item.indexOf(id) ? 'active' : ''
    }
  }
}
</script>

<template>
  <div class="search-bar_container">
    <div class="search-bar_tools">
      <div class="search-bar_filter" @click="show">
        <i class="iconfont iconkecheng-zhankai"></i>筛选
      </div>
      <div class="search-bar_input">
        <div class="search-bar_box">
          <input
            type="text"
            placeholder="请输入搜索内容"
            :value="value"
            @input="input"
            @keydown.enter="search"
          />
          <i class="iconfont iconsearch"></i>
          <button @click="search">搜索</button>
        </div>
      </div>
    </div>
    <Dialog :visible="visible" body @hide="hide">
      <div class="search-bar_list">
        <div v-for="(outer, outerIndex) in list" :key="outer.name" class="search-bar_category">
          <div class="search-bar_label">{{outer.label}}</div>
          <div class="search-bar_sublist">
            <div
              v-for="item in outer.categories"
              :key="item.id"
              @click="select(outerIndex, item.id)"
              class="search-bar_item"
            >
              <div :class="activeClassname(outerIndex, item.id)">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-bar_btns">
        <div class="search-bar_cacel" @click="hide">取消</div>
        <div class="search-bar_confirm" @click="search">确定</div>
      </div>
    </Dialog>
  </div>
</template>

<style lang="stylus">
.search-bar_tools
  page-gutter(10px)
  height 55px
  border-top 1px solid $gray-100
  line-top-1px($gray-100)
  display flex
  justify-content space-between
  align-items center

.search-bar_filter
  .iconfont
    middle-font()
    margin-right 10px

.search-bar_box
  position relative
  height h = 26px
  $top = 4px

  input
    height 100%
    small-font()
    background-color $gray-100
    padding $top (h / 2) $top (h + 6)
    border-radius 999px
    margin-right 10px

    &:placeholder
      color $gray-300

  .iconfont
    position absolute
    top $top - 1
    left (h / 2)

.search-bar_list
  padding 16px 16px 56px
  background-color #fff
  min-height 100%

.search-bar_label
  margin-bottom 10px

.search-bar_sublist
  display flex
  margin 0 -5px
  flex-flow row wrap
  margin-bottom 15px

.search-bar_item
  min-width 33.33%
  padding 0 5px
  height h = 30px
  line-height 30px
  margin-bottom 10px

  > div
    width 100%
    height 100%
    border-radius 999px
    background-color $gray-100
    text-align center
    padding 0 (h / 2)

  > .active
    color #fff
    background-color $primary-color

.search-bar_btns
  position fixed
  width 100%
  bottom 0
  left 0
  display flex
  justify-content space-between
  align-items center
  text-align center
  height 56px
  font-size 16px
  line-height 22px
  background-color #fff
  line-top-1px()

  > div
    flex 1

.search-bar_confirm
  color $primary-color
</style>
